<script>
  import { getContext } from "svelte";
  import { adjust_column_count_to_fit_panel, convert_string_to_float } from '#lib/util.js';
  import Image from './Image.svelte';

  let {
    /** @type {float} number between 0 and 1 */
    focal_point_x,
    /** @type {float} number between 0 and 1 */
    focal_point_y,
    fit_to_frame,
    src,
    width,
    height,
    media_type,
  } = $props();

  let site_settings = getContext('site_settings');

  /** All the aspect-ratios used on the website. Can be customized per brand/ theme */
  const brand_aspect_ratios = $derived([
    { name: 'original', ratio: width / height },
    ...site_settings?.aspect_ratios.map(ratio_str => {
      const ratio = convert_string_to_float(ratio_str);
      return {
        name: ratio_str,
        ratio: ratio
      };
    })
  ]);
  const sorted_aspect_ratios = $derived([...brand_aspect_ratios].sort((a, b) => a.ratio > b.ratio ? -1 : 1));

  const max_panel_size = 400;
  let column_count = $state(1);

  $effect(() => {
    column_count = adjust_column_count_to_fit_panel(sorted_aspect_ratios, max_panel_size, column_count);
  });

</script>


<div 
  class="focal-point-preview" 
  style:--preview-image={`url(${src})`}
  style:column-count={column_count}
>
  {#each sorted_aspect_ratios as {name, ratio}}
    <div 
      class="preview-item"
      style:aspect-ratio={ratio}
      style:background-position={`${focal_point_x * 100}% ${focal_point_y * 100}%`}
      style:background-size={fit_to_frame ? 'contain' : 'cover'}
    >
      <Image 
        {src} 
        {focal_point_x} 
        {focal_point_y} 
        {fit_to_frame}
        {media_type}
        aspect_ratio={ratio} 
        autoplay={false}
      />
      <span class="aspect-ratio-name text-caption">
        {name}
      </span>
    </div>
  {/each}
</div>


<style lang="postcss">
  .focal-point-preview {
    column-gap: var(--size-2);
    column-fill: balance;
    column-fill: balance-all;
    width: 100%;
    min-width: min(400px, 100%);
    height: fit-content;
  }
  .preview-item {
    display: flex;
    align-items: flex-start;
    break-inside: avoid;
    margin-bottom: var(--size-2);
    width: 100%;
    /* background-image: var(--preview-image); */
    background-repeat: no-repeat;
    transition: all 90ms ease-in-out;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: var(--color-default-background-100);
    border: 1px solid var(--color-default-stroke-100);
    position: relative;
    :global(> .media-item) {
      height: 100%;
      width: 100%;
    }
  }
  .preview-item .aspect-ratio-name {
    position: absolute;
    top: 0;
    left: 0;
    width: fit-content;
    height: fit-content;
    z-index: 2;
    padding: var(--size-1);
    background-color: var(--color-default-background);
    border-bottom: 1px solid;
    border-right: 1px solid;
    border-color: var(--color-default-stroke-100);
    border-bottom-right-radius: var(--radius-sm);
  }
</style>